export interface DashboardState {
  PropertyFilterOptions: {id: number, name: string}[];
  selectedProperties: number[];
}

export const initialDashboardState: DashboardState = {
  PropertyFilterOptions: [],
  selectedProperties: [],
}
